import { render, staticRenderFns } from "./MPjh.vue?vue&type=template&id=2ec6e8b2&scoped=true"
import script from "./MPjh.vue?vue&type=script&lang=js"
export * from "./MPjh.vue?vue&type=script&lang=js"
import style0 from "./MPjh.vue?vue&type=style&index=0&id=2ec6e8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec6e8b2",
  null
  
)

export default component.exports